import { UserInfoDto } from '@/models/dtos/userInfoDto'

export class AuthHelper {
  static readonly USER_INFO_KEY = 'user-info'

  static getuserInfo(): UserInfoDto | null {
    const userInfo = localStorage.getItem(AuthHelper.USER_INFO_KEY)

    if (!userInfo) return null

    return JSON.parse(userInfo)
  }

  static setUserInfo(data: any): void {
    localStorage.setItem(AuthHelper.USER_INFO_KEY, JSON.stringify(data))
  }

  static removeUserInfo(): void {
    localStorage.removeItem(this.USER_INFO_KEY)
  }
}
